FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};

    /* ========================================================================
     *  private vars
     * ========================================================================
    */

    //  element
    var NAMESPACE = me.getUID('TBODY_');
    var NUMBERTAB = '[data-fd="numbertab"]';
    var SELECTTAB = '[data-fd="selecttab"]';
    var TEXTTAB = '[data-fd="texttab"]';

    var tbody = null;
    var tableId = null;
    var cellList = [];
    var cellInRow = 0;
    var min = 0;
    var max = 0;
    var currentCell = 2;
    var lastElem = null;

    var key = {
        DOWN: 40,
        UP: 38,
        RIGHT: 39,
        LEFT: 37,
        TAB: 9,
        ENTER: 13,
        ESC: 27
    };


    var inputDefaults = {
        useparent: true,
        parentid: -1,
        callbackprefix: 1,
        tag: 55,
        value: '',
        initial: '',
        comma: true,
        focus: false,
        noedit: false,
        islocked: false
    };


    var selectDefaults = {
        useparent: true,
        parentid: -1,
        callbackprefix: 1,
        tag: 95,
        value: '',
        initial: '',
        noedit: false
    };


    var textDefaults = {
        useparent: true,
        parentid: -1,
        callbackprefix: 1,
        tag: 60,
        value: '',
        initial: '',
        noedit: false
    };


    //  set tabbing
    function setTabbing(container, startCell) {
        //  set list
        if (container !== null) {
            if (typeof container === 'string') {
                tbody = $(container);
            }
        } else {
            tbody = $(container);
        }

        //  bail
        if (tbody.length === 0) {
            return;
        }
        tableId = tbody.parents('table').first().attr('id');

        cellList = [];
        var trList = tbody.find('tr').not('.topheader').not('.footer').not('.no-tabrow');
        var tempCellList = trList.find('td').not('.no-tabcount').not('.hidden');

        //console.log(tempCellList.length)
        if (tempCellList.length === 0) {
            return;
        }

        tempCellList.each(function (i) {
            var td = $(this);
            var id = me.getUID('C_');
            td.attr('id', id);
            td.attr('tabindex', i);
            var cell = {
                id: id,
                cell: td
            };
            cellList.push(cell);
        });

        //  set max
        max = cellList.length;

        //  change to grab second tr on main tbody
        cellInRow = getCellInRow(1);    // not zero based
        if (cellInRow === 0) {
            return;
        }

        //  start cell
        if (startCell !== null && startCell !== '' && !isNaN(startCell)) {
            currentCell = startCell;
        }
  
        setNumberTab();
        setSelectTab();
        setTextTab(); 
        setEvents();
        onTDFocus();
    }


    function setNumberTab() {
        var list = $(NUMBERTAB);
        if (list.length === 0) {
            return;
        }

        list.each(function () {
            var elem = $(this);
            var options = $.extend({}, inputDefaults, elem.data());

            //  set islocked (used in FOX, for focus event)
            options.islocked = options.islocked;

            //  set elem data
            me.setControlItemOptions(elem, options);

            //  set data
            elem.data(options);

            //  no edit
            if (options.noedit) {
                elem.attr('readonly', true);
            }

            var value = elem.val();
            value = me.setNoComma(value);

            value = Number(value);

            if (isNaN(value)) {
                value = (isNaN(Number(elem.data('initial')))) ? Number() : Number(elem.data('initial'));
            }

            elem.data().value = value;

            if (options.comma) {
                value = me.setComma(value);
            }

            elem.val(value);
        });
    }


    function setSelectTab() {
        var list = $(SELECTTAB);
        if (list.length === 0) {
            return;
        }

        list.each(function () {
            var elem = $(this);
            var options = $.extend({}, selectDefaults, elem.data());

            //  set islocked (used in FOX, for focus event)
            options.islocked = options.islocked;

            //  set elem data
            me.setControlItemOptions(elem, options);

            //  set data
            elem.data(options);

            //  no edit
            if (options.noedit) {
                elem.attr('readonly', true);
            }
        });
    }


    function setTextTab() {
        var list = $(TEXTTAB);
        if (list.length === 0) {
            return;
        }

        list.each(function () {
            var elem = $(this);
            var options = $.extend({}, textDefaults, elem.data());

            //  set islocked (used in FOX, for focus event)
            options.islocked = options.islocked;

            //  set elem data
            me.setControlItemOptions(elem, options);

            //  set data
            elem.data(options);

            //  no edit
            if (options.noedit) {
                elem.attr('readonly', true);
            }
        });
    }


    //  get count of cells  in row
    function getCellInRow(rowNumber) {
        try {
            var cellInRow = tbody.find("tr:nth-child(" + rowNumber + ")").children('td').not('.no-tabcount').length;  // not zero based
            if (cellInRow === 0) {
                return getCellInRow(rowNumber + 1);
            }
            return cellInRow;
        } catch (e) {
            return 0;
        }
    }


    //  on focus of td
    function onTDFocus() {
        if (cellList.length === 0) {
            return;
        }
        if (lastElem !== null) {
            $(lastElem).children().removeClass('in');
        }

        //  remove other input highlights (used in part forecast top row)
        $('[data-inputhighlight="true"]').removeClass('in');

        if (cellList.length <= currentCell) {
            currentCell = 0;
        }
        //  get current td
        var td = $('#' + cellList[currentCell].id);
        if (td.length === 0) {
            currentCell = 0;
        }

        //  add hightlight to row
        tbody.find('tr').removeClass('highlight-child-withborder');
        td.parent('tr').addClass('highlight-child-withborder');

        lastElem = '#' + cellList[currentCell].id;

        if (td.hasClass('no-select')) {
            return;
        }
        td.children().addClass('in');

        var e = null;
        if (td.children('input').length > 0) {
            e = td.children('input').first();

            if (e.is('[readonly]')) {
                td.focus();
            } else {
                if (e.is(":focus")) {
                    return;
                }
                e.trigger('focus');
            }
        }

        if (td.children('select').length > 0) {
            e = td.children('select').first();
            if (e.is(":focus")) {
                return;
            }
            e.focus();
        }
    }


    //  set events
    function setEvents() {
        tbody.off('keydown.' + NAMESPACE);
        tbody.on('keydown.' + NAMESPACE, function (event) {
            var tempCell;
            var target = $(event.target);
            var keyCode = Number(event.keyCode) || Number(event.which);

            if (keyCode === key.ESC) {
                var data = target.data();

                if (target.is('[data-fd="numbertab"]')) {
                    var newVal = me.setComma(data.initial);
                    target.val(newVal);
                } else {
                    target.val(data.initial);
                }
              
                me.setInputFocus(target, true);
                return false;
            }

            if (target.is('[data-fd="numbertab"]')) {
                //  allowed key strokes for numbers
                var numarray = [8, 9, 13, 27, 35, 36, 37, 38, 39, 40, 45, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 67, 88, 86,
                    96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 109, 110, 188, 189, 190];
                if (numarray.indexOf(keyCode) === -1) { //|| event.shiftKey
                    event.preventDefault();
                    return false;
                }
            }

            if (keyCode === key.RIGHT) {
                tempCell = (currentCell + 1);
                if (tempCell >= min && tempCell < max) {
                    currentCell = tempCell;
                    onTDFocus();
                    return false;
                }
            }

            if (keyCode === key.ENTER) {
                tempCell = (currentCell + cellInRow);
                if (tempCell >= min && tempCell < max) {
                    currentCell = tempCell;
                    onTDFocus();
                }
            }

            if (keyCode === key.LEFT) {
                tempCell = (currentCell - 1);

                if (tempCell >= min && tempCell <= max) {
                    currentCell = tempCell;
                    onTDFocus();
                    return false;
                }
            }

            if (event.shiftKey && keyCode === key.TAB) {
                tempCell = (currentCell - 1);

                if (tempCell >= min && tempCell <= max) {
                    currentCell = tempCell;
                    onTDFocus();
                    return false;
                }
            }

            if (keyCode === key.DOWN) {
                event.preventDefault();
                tempCell = (currentCell + cellInRow);

                if (tempCell >= min && tempCell < max) {
                    currentCell = tempCell;
                    onTDFocus();
                }
            }

            if (keyCode === key.UP) {
                event.preventDefault();
                tempCell = (currentCell - cellInRow);

                if (tempCell >= min && tempCell <= max) {
                    currentCell = tempCell;
                    onTDFocus();
                }
            }

            if (keyCode === key.TAB) {
                tempCell = (currentCell + 1);

                if (tempCell >= min && tempCell < max) {
                    currentCell = tempCell;
                    onTDFocus();
                    return false;
                }
            }
        });


        tbody.off('keyup.' + NAMESPACE);
        tbody.on('keyup.' + NAMESPACE, function (event) {
            var target = $(event.target);
            var data = target.data();

            if (target.is('[data-fd="numbertab"]')) {
                if (data.islocked) {
                    target.val('Locked');
                    target.select();
                }
            }
        });


        tbody.off('click.' + NAMESPACE);
        tbody.on('click.' + NAMESPACE, 'td', function () {
            var elem = $(this);
            var id = elem.attr('id');

            for (var i = 0, len = cellList.length; i < len; i++) {
                var d = cellList[i];
                if (d.id === id) {
                    currentCell = i;
                    onTDFocus();
                    break;
                }
            }
        });


        $(document).off('click.tbodynremovehl');
        $(document).on('click.tbodynremovehl', function (event) {
            var target = $(event.target);

            if (!target.parents('#' + tableId).length > 0) {
                removeHighLight();
            }
        });


        $(document).off('change.' + NAMESPACE, '#' + tableId + ' ' + SELECTTAB);
        $(document).on('change.' + NAMESPACE, '#' + tableId + ' ' + SELECTTAB, function () {
            var e = $(this);
            e.data().element = e;
            var data = e.data();
            var val = e.val();

            e.data().value = val;
            e.data(data);

            data = e.data();
            me.setCallBackFromData(e, { e: data.element, value: data.value, tag: data.tag, parentid: data.parentid });
        });


        $(document).off('focus.' + NAMESPACE, '#' + tableId + ' ' + NUMBERTAB);
        $(document).on('focus.' + NAMESPACE, '#' + tableId + ' ' + NUMBERTAB, function () {
            var e = $(this);
            var val = Number(e.val().replace(/[^0-9\.\-]+/g, ""));
            var data = e.data();

            if (data.noedit) {
                return;
            }

            data.initial = val.valueOf();

            //  set locked
            var label = me.getLabel();
            if (data.islocked) {
                e.val(label.Locked);
            }

            e.select();
        });


        $(document).off('blur.' + NAMESPACE, '#' + tableId + ' ' + NUMBERTAB);
        $(document).on('blur.' + NAMESPACE, '#' + tableId + ' ' + NUMBERTAB, function () {
            var e = $(this);
            var data = e.data();
            e.data().element = e;  

            var value = e.val();
            value = me.setNoComma(value);
            value = Number(value);

            if (isNaN(value)) {
                value = (isNaN(Number(e.data('initial')))) ? Number() : Number(e.data('initial'));
            }

            e.data().value = value;

            if (data.comma) {
                value = me.setComma(value);
            }

            e.val(value);

            //  noedit
            if (data.noedit) {
                return;
            }

            //  trap for locked
            if (data.islocked) {
                e.val(me.setComma(data.initial));
                return;
            }

            //  callback
            setCallback(e);
        });


        $(document).off('focus.' + NAMESPACE, '#' + tableId + ' ' + TEXTTAB);
        $(document).on('focus.' + NAMESPACE, '#' + tableId + ' ' + TEXTTAB, function () {
            var e = $(this);
            var val = e.val();
            e.data().initial = val;
            e.select();
        });


        $(document).off('blur.' + NAMESPACE, '#' + tableId + ' ' + TEXTTAB);
        $(document).on('blur.' + NAMESPACE, '#' + tableId + ' ' + TEXTTAB, function () {
            var e = $(this);
            e.data().element = e;
            var val = e.val();
            e.val(val);
            e.data().value = val;

            setCallback(e);
        });
    }


    //  remove tbody highlight
    function removeHighLight() {
        tbody.find('tr').removeClass('highlight-child-withborder');
        if (lastElem !== null) {
            $(lastElem).children().removeClass('in');
        }
    }


    //  set callback
    function setCallback(e) {
        var data = e.data();

        //  data locked
        if (data.islocked) {
            return;
        }

        //  value == value
        if (data.value == data.initial) {
            return;
        }

        //  callback
        me.setCallBackFromData(e, {
            e: data.element,
            value: data.value.valueOf(),
            initial: data.initial,
            tag: data.tag,
            parentid: data.parentid,
            length: data.length || 0
        });
    }


    /* ========================================================================
     *  public methods
     * ========================================================================
    */


    child.setTabbing = function (container, startCell) {
        setTabbing(container, startCell);
    };

    return child;
}(jQuery, FD));